import { render, staticRenderFns } from "./AccountSettingCompany.vue?vue&type=template&id=1ae045dd&scoped=true&"
import script from "./AccountSettingCompany.vue?vue&type=script&lang=js&"
export * from "./AccountSettingCompany.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingCompany.vue?vue&type=style&index=0&id=1ae045dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae045dd",
  null
  
)

export default component.exports